import type { Settlement } from './Workorder.types';

// TODO: move Settlement to seperate file as it is now workorder specific

/**
 * Settlement display names (Dutch)
 */
export const SETTLEMENT_LABELS: Record<Settlement, string> = {
  cost_plus: 'Regie',
  contracted: 'Aangenomen',
  quoted: 'Offerte',
  final_account: 'Nacalculatie',
  archived: 'Archief',
  invoiced: 'Gefactureerd',
  warranty: 'Garantie',
};

/**
 * Gets the display name for a settlement type
 * @param settlement - The settlement type enum value
 * @returns Human-readable settlement name or null
 */
export function getSettlementLabel(
  settlement: Settlement | null,
): string | null {
  if (!settlement) return null;
  return SETTLEMENT_LABELS[settlement] ?? settlement;
}
